import React from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import BottomNavigation from '../components/BottomNavigation';

const AppLayout: React.FC = () => {
  const location = useLocation();

  // Pages without bottom navigation (full-screen focus)
  const noNavPages = ['/login', '/register', '/forgot-pin', '/registration-success', '/send', '/track'];
  const hasNav = !noNavPages.includes(location.pathname) && !location.pathname.startsWith('/shop/') && !location.pathname.startsWith('/track');

  return (
    <div className="flex flex-col min-h-screen bg-white md:bg-gray-50 overflow-x-hidden selection:bg-blue-100">
      {/* 
        Main content area with smooth page transitions.
        Native-style slide-up animation for better mobile feel.
      */}
      <main className={`flex-grow transition-all duration-300 ${hasNav ? 'pb-20 md:pb-0' : ''}`}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
            className="w-full h-full min-h-screen-safe"
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>

      {/* Mobile-only bottom navigation */}
      <BottomNavigation />
    </div>
  );
};

export default AppLayout;
